const data = {
  counterText: 'सीमित स्लॉट उपलब्ध',
  loading: 'लादने का',
  next: 'अगला प्रश्न',
  previous: 'पिछला',
  smCounterText: 'सीमित स्लॉट्स छोड़े गए.',
};

export default data;
